// extracted by mini-css-extract-plugin
export default {"account":"AccountMessage-module--account--ba0c7"};